function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "cal1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0 101 L 300 101 L 300 382.105469 L 0 382.105469 Z M 0 101 "
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "cal2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 38 67.855469 L 56 67.855469 L 56 115 L 38 115 Z M 38 67.855469 "
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "cal3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 89 67.855469 L 107 67.855469 L 107 115 L 89 115 Z M 89 67.855469 "
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "cal4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 141 67.855469 L 159 67.855469 L 159 115 L 141 115 Z M 141 67.855469 "
}));

var _ref6 = /*#__PURE__*/React.createElement("clipPath", {
  id: "cal5"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 192 67.855469 L 210 67.855469 L 210 115 L 192 115 Z M 192 67.855469 "
}));

var _ref7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "cal6"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 243 67.855469 L 261 67.855469 L 261 115 L 243 115 Z M 243 67.855469 "
}));

var _ref8 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-1",
  x: 94.288313,
  y: 303.093897
});

var _ref9 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#glyph0-2",
  x: 131.343948,
  y: 303.093897
});

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "60px",
    viewBox: "0 0 300 449.999984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.234375 -87.828125 C 6.234375 -88.828125 6.585938 -89.679688 7.296875 -90.390625 C 8.003906 -91.097656 8.859375 -91.453125 9.859375 -91.453125 L 27.203125 -91.453125 C 28.203125 -91.453125 29.050781 -91.097656 29.75 -90.390625 C 30.457031 -89.679688 30.8125 -88.828125 30.8125 -87.828125 L 30.8125 -3.625 C 30.8125 -2.625 30.457031 -1.769531 29.75 -1.0625 C 29.050781 -0.351562 28.203125 0 27.203125 0 L 20.34375 0 C 19.34375 0 18.488281 -0.351562 17.78125 -1.0625 C 17.070312 -1.769531 16.71875 -2.625 16.71875 -3.625 L 16.71875 -73.734375 C 16.71875 -74.734375 16.363281 -75.585938 15.65625 -76.296875 C 14.945312 -77.003906 14.09375 -77.359375 13.09375 -77.359375 L 9.859375 -77.359375 C 8.859375 -77.359375 8.003906 -77.707031 7.296875 -78.40625 C 6.585938 -79.113281 6.234375 -79.96875 6.234375 -80.96875 Z M 6.234375 -87.828125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 37.671875 -62.390625 C 42.585938 -62.222656 47.125 -61.035156 51.28125 -58.828125 C 55.4375 -56.617188 58.882812 -53.707031 61.625 -50.09375 C 64.375 -46.476562 66.289062 -42.335938 67.375 -37.671875 C 68.457031 -33.015625 68.375 -28.234375 67.125 -23.328125 C 65.707031 -17.921875 63.375 -13.46875 60.125 -9.96875 C 56.882812 -6.476562 53.207031 -3.898438 49.09375 -2.234375 C 44.976562 -0.578125 40.628906 0.164062 36.046875 0 C 31.472656 -0.164062 27.171875 -1.179688 23.140625 -3.046875 C 19.109375 -4.921875 15.570312 -7.625 12.53125 -11.15625 C 9.5 -14.695312 7.441406 -19.046875 6.359375 -24.203125 C 6.109375 -25.285156 6.296875 -26.242188 6.921875 -27.078125 C 7.546875 -27.910156 8.398438 -28.410156 9.484375 -28.578125 L 16.21875 -29.4375 C 17.132812 -29.601562 17.96875 -29.414062 18.71875 -28.875 C 19.46875 -28.34375 19.96875 -27.617188 20.21875 -26.703125 C 20.875 -23.953125 22.054688 -21.640625 23.765625 -19.765625 C 25.472656 -17.898438 27.425781 -16.488281 29.625 -15.53125 C 31.832031 -14.570312 34.160156 -14.070312 36.609375 -14.03125 C 39.066406 -13.988281 41.414062 -14.425781 43.65625 -15.34375 C 45.90625 -16.257812 47.90625 -17.671875 49.65625 -19.578125 C 51.40625 -21.492188 52.65625 -23.910156 53.40625 -26.828125 C 54.226562 -30.316406 54.097656 -33.554688 53.015625 -36.546875 C 51.941406 -39.546875 50.257812 -42.039062 47.96875 -44.03125 C 45.6875 -46.03125 42.984375 -47.34375 39.859375 -47.96875 C 36.742188 -48.59375 33.601562 -48.28125 30.4375 -47.03125 C 29.363281 -46.53125 28.285156 -46.613281 27.203125 -47.28125 L 18.84375 -52.65625 C 17.34375 -53.644531 16.800781 -54.972656 17.21875 -56.640625 L 25.703125 -88.703125 C 25.867188 -89.535156 26.285156 -90.203125 26.953125 -90.703125 C 27.617188 -91.203125 28.363281 -91.453125 29.1875 -91.453125 L 64 -91.453125 C 65 -91.453125 65.875 -91.097656 66.625 -90.390625 C 67.375 -89.679688 67.75 -88.828125 67.75 -87.828125 L 67.75 -80.96875 C 67.75 -79.96875 67.375 -79.113281 66.625 -78.40625 C 65.875 -77.707031 65 -77.359375 64 -77.359375 L 39.671875 -77.359375 C 38.835938 -77.359375 38.085938 -77.109375 37.421875 -76.609375 C 36.765625 -76.109375 36.351562 -75.441406 36.1875 -74.609375 L 34.1875 -66.875 C 33.851562 -65.707031 34.0625 -64.664062 34.8125 -63.75 C 35.5625 -62.84375 36.515625 -62.390625 37.671875 -62.390625 Z M 37.671875 -62.390625 "
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7), /*#__PURE__*/React.createElement("g", {
    id: "calendaricon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cal1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(66.668701%,78.039551%,83.139038%)",
      fillOpacity: 1
    },
    d: "M 299.890625 366.648438 C 299.890625 375.148438 292.980469 382.039062 284.480469 382.039062 L 15.628906 382.039062 C 7.128906 382.039062 0.238281 375.148438 0.238281 366.648438 L 0.238281 116.511719 C 0.238281 108.011719 7.128906 101.121094 15.628906 101.121094 L 284.480469 101.121094 C 292.980469 101.121094 299.890625 108.011719 299.890625 116.511719 L 299.890625 366.648438 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.19928%,92.549133%,93.328857%)",
      fillOpacity: 1
    },
    d: "M 299.359375 350.507812 C 299.359375 359.519531 292.066406 366.8125 283.054688 366.8125 L 16.234375 366.8125 C 7.238281 366.8125 -0.0546875 359.519531 -0.0546875 350.507812 L -0.0546875 103.769531 C -0.0546875 94.757812 7.238281 87.464844 16.234375 87.464844 L 283.054688 87.464844 C 292.066406 87.464844 299.359375 94.757812 299.359375 103.769531 L 299.359375 350.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,70.588684%,61.959839%)",
      fillOpacity: 1
    },
    d: "M 299.359375 155.136719 L 299.359375 103.769531 C 299.359375 94.757812 292.066406 87.464844 283.054688 87.464844 L 16.234375 87.464844 C 7.238281 87.464844 -0.0546875 94.757812 -0.0546875 103.769531 L -0.0546875 155.136719 L 299.359375 155.136719 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cal2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.19928%,92.549133%,93.328857%)",
      fillOpacity: 1
    },
    d: "M 55.355469 105.945312 C 55.355469 110.644531 51.554688 114.464844 46.855469 114.464844 C 42.15625 114.464844 38.355469 110.644531 38.355469 105.945312 L 38.355469 76.441406 C 38.355469 71.746094 42.15625 67.941406 46.855469 67.941406 C 51.554688 67.941406 55.355469 71.746094 55.355469 76.441406 L 55.355469 105.945312 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cal3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.19928%,92.549133%,93.328857%)",
      fillOpacity: 1
    },
    d: "M 106.746094 105.945312 C 106.746094 110.644531 102.941406 114.464844 98.261719 114.464844 C 93.546875 114.464844 89.742188 110.644531 89.742188 105.945312 L 89.742188 76.441406 C 89.742188 71.746094 93.546875 67.941406 98.261719 67.941406 C 102.941406 67.941406 106.746094 71.746094 106.746094 76.441406 L 106.746094 105.945312 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cal4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.19928%,92.549133%,93.328857%)",
      fillOpacity: 1
    },
    d: "M 158.152344 105.945312 C 158.152344 110.644531 154.351562 114.464844 149.652344 114.464844 C 144.953125 114.464844 141.152344 110.644531 141.152344 105.945312 L 141.152344 76.441406 C 141.152344 71.746094 144.953125 67.941406 149.652344 67.941406 C 154.351562 67.941406 158.152344 71.746094 158.152344 76.441406 L 158.152344 105.945312 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cal5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.19928%,92.549133%,93.328857%)",
      fillOpacity: 1
    },
    d: "M 209.5625 105.945312 C 209.5625 110.644531 205.742188 114.464844 201.042969 114.464844 C 196.363281 114.464844 192.558594 110.644531 192.558594 105.945312 L 192.558594 76.441406 C 192.558594 71.746094 196.363281 67.941406 201.042969 67.941406 C 205.742188 67.941406 209.5625 71.746094 209.5625 76.441406 L 209.5625 105.945312 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cal6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.19928%,92.549133%,93.328857%)",
      fillOpacity: 1
    },
    d: "M 260.949219 105.945312 C 260.949219 110.644531 257.148438 114.464844 252.449219 114.464844 C 247.75 114.464844 243.949219 110.644531 243.949219 105.945312 L 243.949219 76.441406 C 243.949219 71.746094 247.75 67.941406 252.449219 67.941406 C 257.148438 67.941406 260.949219 71.746094 260.949219 76.441406 L 260.949219 105.945312 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 80,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(13.729858%,14.118958%,20.779419%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 1843.406047 2075.192201 C 1893.191597 2132.099392 1971.502343 2238.797703 1971.502343 2238.797703 L 1971.502343 1703.895754 ",
    transform: "matrix(0.182815,0,0,-0.182795,-238.756822,613.604064)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 80,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "rgb(13.729858%,14.118958%,20.779419%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 2130.60243 1705.904494 L 2251.604819 1705.904494 C 2263.591812 1706.60969 2275.108727 1705.989973 2287.309391 1707.891865 C 2358.590333 1719.089525 2414.807406 1760.396923 2435.597681 1829.890796 C 2452.990572 1887.994683 2449.700025 1963.493408 2399.893108 2006.809546 C 2362.009083 2039.889655 2307.009939 2036.299566 2259.895288 2036.299566 L 2130.60243 2036.299566 L 2130.60243 2236.810332 L 2378.910529 2236.810332 ",
    transform: "matrix(0.182815,0,0,-0.182795,-238.756822,613.604064)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.19928%,92.549133%,93.328857%)",
      fillOpacity: 1
    },
    d: "M 67.5 180.234375 L 232.828125 180.234375 L 232.828125 345.5625 L 67.5 345.5625 Z M 67.5 180.234375 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(43.139648%,50.979614%,54.508972%)",
      fillOpacity: 1
    }
  }, _ref8), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(43.139648%,50.979614%,54.508972%)",
      fillOpacity: 1
    }
  }, _ref9)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.fe69dcb0.svg";
export { ForwardRef as ReactComponent };